import React from 'react';

import { StyledIcon } from '../StyledIcon';

export const CloudSoftware = props => (
  <StyledIcon viewBox='0 0 24 24' a11yTitle='CloudSoftware' {...props}>
    <path fill='none' stroke='#000' strokeWidth='2' d='M8,23 L16,23 L16,12 L8,12 L8,23 Z M8,16 L16,16 M12,12 L12,16 M6,6 L6,5 C6,2 7.5,1 10,1 L14,1 C16.5,1 18,2.5 18,5 L18,6 C21,6 23,8 23,11 C23,14 21,16 18,16 M14,6 L6,6 C3,6 1,7.5 1,11 C1,14.5 3,16 6,16' />
  </StyledIcon>
);
